document.addEventListener("DOMContentLoaded", () => {
	checkSmartBanner();
});
window.addEventListener("resize", () => {
	checkSmartBanner();
});

function checkSmartBanner() {
	let banner = document.querySelector(".smart-banner-section");
	if (!banner) return;

	if (window.innerWidth < 768) {
		let storage = sessionStorage.getItem("smartBanner");
		let moneyFastFormButtons = document.querySelectorAll(".money-fast-form .btn");
		let loansSection = document.querySelectorAll(".best-personal-loans-section");
		let creditBlockButtons;
		if (loansSection.length) {
			creditBlockButtons = loansSection[loansSection.length - 1].querySelectorAll(".list-holder .credit-block .btn");
		} else {
			creditBlockButtons = document.querySelectorAll(".credit-block .btn");
		}

		window.addEventListener("scroll", addSmartBannerClass);

		function addSmartBannerClass() {
			if (moneyFastFormButtons.length) {
				// let elTopOffset = moneyFastFormButtons[moneyFastFormButtons.length - 1].getBoundingClientRect().top;
				// bannerClassHandler(elTopOffset);
				bannerClassHandler(window.scrollY * -1);
			} else {
				if (creditBlockButtons.length) {
					// let elTopOffset = creditBlockButtons[creditBlockButtons.length - 1].getBoundingClientRect().top;
					// bannerClassHandler(elTopOffset);
					bannerClassHandler(window.scrollY * -1);
				}
			}
		}

		function bannerClassHandler(el) {
			if (el >= 0) {
				if (document.body.classList.contains("smart-banner-active")) {
					document.body.classList.remove("smart-banner-active");
				}
			} else {
				if (!storage) {
					if (!document.body.classList.contains("smart-banner-active") && !document.body.classList.contains("smart-banner-hidden")) {
						document.body.classList.add("smart-banner-active");
					}
					if (banner) {
						banner.addEventListener("click", (e) => {
							if (e.target.classList.contains("close-banner-btn")) {
								e.preventDefault();
								document.body.classList.remove("smart-banner-active");
								document.body.classList.add("smart-banner-hidden");
								sessionStorage.setItem("smartBanner", "hidden");
							}
						});
					}
				}
			}
		}
	}
}
